import React, { useEffect } from 'react'
import { Box, Modal } from '@mui/material'

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  //width: 400,
  bgcolor: 'background.paper',
  border: '1px solid #CCCCCC',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
  overlay: {
    background: '#FFFF00',
  }
}

export const ModalComponent = ({ children, buttonText = 'Open Modal', isOpen = false, handleModalClose }: any) => {
  const [open, setOpen] = React.useState(isOpen)
  const handleClose = () => {
    setOpen(false)
    handleModalClose()
  }

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  return <div>
    {/* <Button onClick={handleOpen}>{buttonText}</Button> */}
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {children}
      </Box>
    </Modal>
  </div>
}